/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @ngdoc constant
 * @name policyRuleSort
 * @type Function
 * @description
 *
 *     Sorts policy rules based on index.
 */
angular.module('aviApp').constant('policyRuleSort', function(ruleA, ruleB) {
    const
        { index: indexA } = ruleA,
        { index: indexB } = ruleB;

    return indexA - indexB;
});
